import {
  Component,
  ChangeDetectionStrategy,
  NgZone,
  ElementRef,
} from "@angular/core";
import { NavigationItemModel } from "../common/sideNav/navigationItem.model";
import libraryStore from "../../services/stores/library.store";
import { LibraryTypes } from "../../domain/enums";
import { UI } from "../../services/ui.service";

@Component({
  selector: "icn-autopilot",
  templateUrl: "./autopilot.component.html",
  styleUrls: ["./autopilot.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AutopilotComponent {
  filterOpen = false;
  filterTranslateValue = "";

  navigationItems: NavigationItemModel[] = [
    //(new NavigationItemModel(LibraryTypes.VideoRules, 'rule-icon', 'video rules')),
    new NavigationItemModel(
      LibraryTypes.AutopilotRules,
      "rule-icon",
      "autopilot rules",
    ),
    new NavigationItemModel(LibraryTypes.Graphics, "graphics-icon", "graphics"),
    new NavigationItemModel(LibraryTypes.Video, "graphics-icon", "media"),
  ];

  libraryStore = libraryStore;

  constructor(
    private ui: UI,
    private element: ElementRef,
  ) {}
  ngOnDestroy() {
    window.removeEventListener("resize", this.onResizeWindow, false);
  }
  /**
   * Component init
   * @return void
   */
  ngOnInit() {
    window.addEventListener("resize", this.onResizeWindow.bind(this), false);

    /* Setup Filter Left Position */
    this.setupFilterLeftPosition();

    /* Adding listener to filter toggle */
    this.ui.listen(
      this.ui.EVENTS.LibraryFilterToggle,
      this.onLibraryFilterToggle.bind(this),
    );
  }
  onResizeWindow(event) {
    this.setupFilterLeftPosition();
    this.filterOpen = false;
  }

  /**
   * Dispatched in case of filter toggle (Should display / Hide Filter)
   * @param event
   * @return void
   */
  onLibraryFilterToggle(event) {
    this.filterOpen = !this.filterOpen;

    const $filter = this.element.nativeElement.querySelector("filter");
    if ($filter) {
      /* Perform open set of operations */
      this.ui.setCssProperty($filter, {
        transform:
          "translateX(" +
          (this.filterOpen ? "0" : "-" + this.filterTranslateValue) +
          ")",
      });
    }
  }

  /**
   * Setup Filter Left Position
   * @return void
   */
  setupFilterLeftPosition() {
    /* Getting Filter Element */
    const $filter = this.element.nativeElement.querySelector("filter");

    if ($filter == null || !$filter) return;

    /* Getting Computed Element */
    const asideWidth = this.ui.getComputedElement(
      this.element.nativeElement.querySelector("aside"),
      "width",
    );
    const tabsWidth = this.ui.getComputedElement(
      document.querySelector("icn-sidebar-nav"),
      "width",
    );

    const filterWidth = this.ui.getComputedElement($filter, "width");

    /* Assign Filter Translate Value */
    this.filterTranslateValue = filterWidth;
    // console.log("FILTER WIDTH: ", filterWidth, "--->?", "translateX(" + this.filterTranslateValue + ")" );

    const leftPosition = parseFloat(asideWidth) + parseFloat(tabsWidth);

    this.ui.setCssProperty($filter, {
      left: `${leftPosition}px`,
      transform: "translateX(-" + this.filterTranslateValue + ")",
    });
  }
}
